/**
 * DeveloperRequestDetailPage
 *
 * Page wrapper for Developer Request Detail.
 *
 * @module pages/dev/DeveloperRequestDetailPage
 */

import React from 'react';
import { Box, Container } from '@mui/material';
import DeveloperRequestDetail from '../../components/dev/DeveloperRequestDetail';

/**
 * DeveloperRequestDetailPage
 */
const DeveloperRequestDetailPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box py={4}>
        <DeveloperRequestDetail />
      </Box>
    </Container>
  );
};

export default DeveloperRequestDetailPage;
